import React, { useEffect } from 'react'
import HomeOriginal from './components/home-original'
import HomeVideo from './components/home-video'
import HomeLive from './components/home-live'
import HomeFeed from './components/home-feed'
import { IFriendshipLinkData } from './components/friendship-link'
import Head from 'next/head'
import ChooseCar from './components/choose-car'
import DongCheFen from './components/dong-che-fen'
import CarAtlas from './components/car-atlas'
import { getNewCarData } from './components/choose-car/new-car'
import { getPopularModels } from './components/choose-car/popular-model'

import {
  getHomeOriginal,
  ICommonVideoData,
  getTodayNews,
  getFocusPic,
  getPGCVideoRank,
  getPGCArticleRank,
  ICommonContentRankItem,
} from './services/home'
import Banner, { PicList } from './components/banner'
import TodayNews, { MisData } from './components/today-news'

interface IProps {
  homeOriginal: {
    video_list: ICommonVideoData[]
    column_tab: { column_id: number; name: string }[]
  }
  friendshipLinkData: IFriendshipLinkData[]
  categoryListOriginalData: string[]
  todayNews: MisData[]
  focusPic: PicList
  videoPGCRankData: ICommonContentRankItem[]
  [key: string]: any
}

export default function Home(data: IProps) {
  // usePageLeave()
  useEffect(() => {
    window.onbeforeunload = function () {
      window.scrollTo(0, 0)
    }
    return () => {
      window.onbeforeunload = null
    }
  })

  return (
    <div className="homepage tw-w-full tw-h-full">
      <Head>
        <link rel="canonical" href="https://www.dongchedi.com" />
      </Head>
      <ChooseCar
        newCarData={data?.newCarData}
        popularModels={data?.popularModels}
      />
      <div className="tw-grid tw-grid-cols-40 tw-gap-12 tw-w-full tw-mb-24">
        <Banner focus_pic={data?.focusPic} />
        <TodayNews todayNews={data?.todayNews} />
      </div>
      <HomeOriginal
        data={data?.homeOriginal?.video_list}
        categoryListPGCData={data?.homeOriginal?.column_tab}
      />
      <DongCheFen />
      <HomeVideo videoPGCRankData={data?.videoPGCRankData} />
      <HomeLive />
      <CarAtlas />
      <HomeFeed
        friendshipLinkData={data?.friendshipLinkData}
        articlePGCRankData={data?.articlePGCRankData}
      />
      <style jsx>
        {`
          :global(.banner) {
            position: relative !important;
          }
        `}
      </style>
    </div>
  )
}

Home.getInitialProps = async ({ req }: any): Promise<IProps> => {
  const data = await Promise.all([
    getHomeOriginal(req),
    Promise.resolve(),
    Promise.resolve(),
    getNewCarData(req),
    getPopularModels(req),
    getTodayNews(req),
    getFocusPic(req),
    getPGCVideoRank(req),
    getPGCArticleRank(req),
  ])
  return {
    _pageType: 'new',
    homeOriginal: data?.[0],
    friendshipLinkData: null!,
    categoryListOriginalData: null!,
    newCarData: data?.[3],
    popularModels: data?.[4],
    todayNews: data?.[5],
    focusPic: data?.[6],
    videoPGCRankData: data?.[7],
    articlePGCRankData: data?.[8],
  }
}
